<template>
  <div class="text-center mb-4">
    <h4>Sistem Penerimaan Murid Baru</h4>
    <img alt="SKAPSA logo" class="my-2" width="150" src="../assets/logo.png">
    <div class="hstack gap-1 justify-content-center">
      <h4 class="mb-0">SMK PGRI 1 KEDIRI {{ taAktif.nama }}</h4>
      <div class="vr"></div>
      <button class="btn btn-sm btn-outline-dark border-0 h-100" v-tooltip="'QR Code Grup WA'" @click="generateQRCode">
        <svg xmlns="http://www.w3.org/2000/svg" height="16" fill="currentColor" class="bi bi-qr-code d-flex"
          viewBox="0 0 16 16">
          <path d="M2 2h2v2H2V2Z" />
          <path d="M6 0v6H0V0h6ZM5 1H1v4h4V1ZM4 12H2v2h2v-2Z" />
          <path d="M6 10v6H0v-6h6Zm-5 1v4h4v-4H1Zm11-9h2v2h-2V2Z" />
          <path
            d="M10 0v6h6V0h-6Zm5 1v4h-4V1h4ZM8 1V0h1v2H8v2H7V1h1Zm0 5V4h1v2H8ZM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8H6Zm0 0v1H2V8H1v1H0V7h3v1h3Zm10 1h-1V7h1v2Zm-1 0h-1v2h2v-1h-1V9Zm-4 0h2v1h-1v1h-1V9Zm2 3v-1h-1v1h-1v1H9v1h3v-2h1Zm0 0h3v1h-2v1h-1v-2Zm-4-1v1h1v-2H7v1h2Z" />
          <path d="M7 12h1v3h4v1H7v-4Zm9 2v2h-3v-1h2v-1h1Z" />
        </svg>
      </button>
    </div>
  </div>
  <info-jurusan />
  <div class="modal fade" id="qrCodePendaftar" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <legend class="modal-title">Pendaftar SPMB {{ taAktif.tahun_ajaran_id }}</legend>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body text-center">
          <h6 class="modal-title">Grup WhatsApp</h6>
          <canvas class="border border-1" ref="qrCodeCanvasPendaftar"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import InfoJurusan from '@/components/InfoJurusan.vue'
import QRCode from 'qrcode';
import { Modal } from 'bootstrap';

export default {
  name: 'HomeView',
  data() {
    return {
      url: null
    };
  },
  components: {
    InfoJurusan,
  },
  computed: {
    user() {
      return this.$store.state.userData;
    },
    taAktif() {
      return this.$store.getters.getTahunAjaran
    }
  },
  mounted() {
    this.getLinkWa()
  },
  watch: {
  },
  methods: {
    async getLinkWa() {
      try {
        const response = await this.axios.post(this.$umum + "/get-url", { short: 'pendaftar-ppdb' }, {});
        if (response.data) {
          this.url = response.data.url?.long_url;
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status == 401) {
            this.$swal({
              title: 'Gagal',
              text: 'Sesi berakhir. Silakan login ulang.',
              icon: 'error',
              confirmButtonText: 'Baik'
            }).then(() => {
              this.$store.dispatch('logoutUser');
              window.location.href = this.$sso + "/" + this.$appId;
            });
          } else {
            console.log(error);
          }
        } else {
          console.log(error)
        }
      }
    },
    generateQRCode() {
      if (!this.url) {
        this.$swal({
          title: 'Perhatian',
          text: `URL untuk gabung Grup WhatsApp tidak ditemukan!`,
          icon: 'info',
          showConfirmButton: true,
        });
      }
      const qrCodeModal = new Modal(document.getElementById('qrCodePendaftar'));
      qrCodeModal.show();
      const text = this.url
      const canvas = this.$refs.qrCodeCanvasPendaftar
      canvas.style.backgroundColor = 'transparent'

      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)

      QRCode.toDataURL(text, function (error, url) {
        if (error) {
          console.error(error)
        } else {
          const img = new Image()
          img.src = url
          img.onload = function () {
            canvas.width = img.width
            canvas.height = img.height

            ctx.fillStyle = 'white'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0)
          }
        }
      }.bind(this))
    },
  }
}
</script>
